import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "safe-area-top bg-brand-black sticky top-0 z-40" }
const _hoisted_2 = { class: "flex p-4 border-b border-brand-dark-gray border-opacity-80 justify-between" }
const _hoisted_3 = {
  key: 0,
  class: "flex w-full h-96 py-80"
}
const _hoisted_4 = { class: "flex px-4 flex-col space-y-8 my-auto py-8" }
const _hoisted_5 = { class: "flex flex-col w-full space-y-1 px-2" }
const _hoisted_6 = { class: "flex text-white text-2xl font-medium" }
const _hoisted_7 = { class: "text-brand-light-gray text-base" }
const _hoisted_8 = { class: "flex flex-col w-full space-y-2 px-2" }
const _hoisted_9 = { class: "text-brand-light-gray text-base" }
const _hoisted_10 = { class: "text-brand-light-gray text-base" }
const _hoisted_11 = { class: "text-brand-light-gray text-base" }
const _hoisted_12 = { class: "text-brand-light-gray text-base" }
const _hoisted_13 = { class: "text-brand-light-gray text-base" }
const _hoisted_14 = { class: "px-4 sticky backdrop-blur-md bottom-0 py-5 flex flex-col border-t border-brand-dark-gray border-opacity-80" }
const _hoisted_15 = { class: "flex m-auto space-x-2.5" }
const _hoisted_16 = { class: "my-auto pt-0.5" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_ion_buttons, { class: "justify-between flex" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _ctx.goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("svg", {
                        class: "",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M6 11.9961H18",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M12 18L6 12L12 6",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { class: "justify-between flex opacity-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { class: "bg-brand-dark-gray rounded-md" }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("svg", {
                        class: "",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M6 11.9961H18",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M12 18L6 12L12 6",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("svg", {
                  class: "animate-spin h-10 w-10 m-auto text-white",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  })
                ], -1)
              ]))]))
            : _createCommentVNode("", true),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, "Block " + _toDisplayString(_ctx.user.name), 1),
                    _createElementVNode("div", _hoisted_7, "Blocking " + _toDisplayString(_ctx.user.name) + " will prevent them from interacting with your account in the following ways: ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-brand-light-gray text-base" }, "• Won’t be able to see your profile.", -1)),
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-brand-light-gray text-base" }, "• Won't be able to see your posts.", -1)),
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-brand-light-gray text-base" }, "• Won't be able to see your messages in group chats.", -1)),
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-brand-light-gray text-base" }, "• They will be removed from any group chats where you are the group admin.", -1)),
                    _createElementVNode("div", _hoisted_9, "• Direct messages between you and " + _toDisplayString(_ctx.user.name) + " will be hidden for both parties.", 1),
                    _createElementVNode("div", _hoisted_10, "• You and " + _toDisplayString(_ctx.user.name) + " will no longer be friends.", 1),
                    _createElementVNode("div", _hoisted_11, "• You won't receive messages from " + _toDisplayString(_ctx.user.name) + ".", 1),
                    _createElementVNode("div", _hoisted_12, "• You won't be able to see posts by " + _toDisplayString(_ctx.user.name) + ".", 1),
                    _createElementVNode("div", _hoisted_13, "• You can unblock " + _toDisplayString(_ctx.user.name) + " from your profile settings.", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.blockUser && _ctx.blockUser(...args))),
                    class: "mt-4 flex w-full bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black transition-all"
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        (!_ctx.busy)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Block " + _toDisplayString(_ctx.user.name), 1))
                          : _createCommentVNode("", true),
                        (_ctx.busy)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[8] || (_cache[8] = [
                              _createElementVNode("svg", {
                                class: "animate-spin h-5 w-5 text-brand-black",
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("circle", {
                                  class: "opacity-25",
                                  cx: "12",
                                  cy: "12",
                                  r: "10",
                                  stroke: "currentColor",
                                  "stroke-width": "4"
                                }),
                                _createElementVNode("path", {
                                  class: "opacity-75",
                                  fill: "currentColor",
                                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                })
                              ], -1)
                            ]))]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "safe-area-bottom" }, null, -1))
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}